function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-59.302 -228.41)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-36.286 168.13)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.33526 0 0 .33526 193.29 114.51)",
  strokeWidth: 2.9828
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -14.093)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -284.53,
  y: -90.133,
  width: 224.35,
  height: 157.72,
  ry: 78.858,
  fill: "#f55"
}), /*#__PURE__*/React.createElement("rect", {
  x: -284.53,
  y: -90.133,
  width: 224.35,
  height: 79.647,
  ry: 0,
  fill: "#f55"
}), /*#__PURE__*/React.createElement("g", {
  className: "lid"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "scale(1,-1)",
  x: -291.42,
  y: 92.68,
  width: 238.12,
  height: 23.812,
  ry: 6.0274,
  fill: "#f36262"
}), /*#__PURE__*/React.createElement("path", {
  d: "m-194.98-143.07h45.245c7.1597 0-13.531 20.468-13.531 20.468h-18.184s-20.69-20.468-13.531-20.468z",
  fill: "#f55"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "scale(1,-1)",
  x: -264.59,
  y: 116.31,
  width: 184.46,
  height: 6.9654,
  ry: 3.4827,
  fill: "#ff8a8a"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "scale(1,-1)",
  x: -196.56,
  y: 139.81,
  width: 48.402,
  height: 7.8437,
  ry: 2.2961,
  fill: "#f55"
}))))));

function SvgPot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "pot",
    viewBox: "0 0 79.833822 72.161223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPot);
export default __webpack_public_path__ + "static/media/pot.d54daed7.svg";
export { ForwardRef as ReactComponent };